import silver from '../../utils/images/silver.svg';
import satellite from '../../utils/images/satellite.svg';
import { Heading, TypographyColor, TypographyType } from '../../ui-elements';
import { useState } from 'react';
import { MAP_STYLES } from '../../constants';

interface MapLayersProps {
    handleMapType: (type: 'roadmap' | 'hybrid' | 'map' | 'dark') => void;
    mapType: 'roadmap' | 'hybrid' | 'map' | 'dark';
    handleCloseRegionCard?: () => void;
}

export const MapLayers: React.FC<MapLayersProps> = ({ handleMapType, mapType, handleCloseRegionCard }) => {
    const [expandList, setExpandList] = useState(false);
    const handleToggle = () => {
        setExpandList(!expandList);
    }

    const handleSelectMapType = (key: 'roadmap' | 'hybrid' | 'map' | 'dark') => {
        handleMapType(key);
        handleCloseRegionCard?.();
    }

    return (
        <>
            <div
                className="map-type-container d-flex"
                onMouseEnter={handleToggle}
                onMouseLeave={handleToggle}
            >
                <div className="cursor-pointer padding-right-3 h-100">
                    <div className="position-relative h-100">
                        <div className="map-type-icon-text position-absolute w-100 d-flex">
                            {/* {showLabel ?
                                    <p title="Map Type" className={`w-100 text ff-poppins-medium fs-12 d-flex justify-content-center p-0 m-0 ${mapType === 'roadmap' ? 'color-white' : 'color-black'}`}>
                                        {mapType === 'roadmap' ? 'Silver' :
                                            mapType === 'hybrid' ? 'Satellite' : 'Map'}
                                    </p> : */}
                            <p title="Map Type" className={`w-100 text-center ff-poppins-medium d-flex justify-content-center p-0 m-0 ${mapType === 'hybrid' || mapType === 'dark' ? 'color-black' : 'color-white'}`}>
                                <span className="material-symbols-outlined fs-16 d-flex align-items-center">layers</span>
                                Layers
                            </p>
                            {/* } */}
                        </div>
                        <img src={mapType === 'hybrid' || mapType === 'dark' ? silver : satellite} alt="map view" className='h-100' />
                    </div>
                </div>
                {expandList &&
                    <div className="rounded map-layer-list">
                        {MAP_STYLES.map(({ key, label, image }: any) => (
                            <div key={key} className={`padding-2 ${mapType === key ? 'selected' : ''}`} onClick={() => handleSelectMapType(key)}>
                                <div className='map-layer-list-img'>
                                    <img src={image} alt={`${label} map`} className='h-100 w-auto'
                                    />
                                </div>
                                <Heading
                                    title={label}
                                    type={TypographyType.h7}
                                    colour={mapType === key ? TypographyColor.primary : TypographyColor.muted}
                                    classname='text-center padding-top-1 m-0'
                                />
                            </div>
                        ))}
                    </div>
                }
            </div>
        </>
    )
}